import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

// Update Admin Profile with Image
export const UpdateAdminProfile = createAsyncThunk(
  "adminProfile/update",
  async (formData, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");

      const response = await axios.put(
        `${BASE_URL}/admin/update-profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to update profile",
      });
    }
  }
);

// Change Admin Password
export const ChangeAdminPassword = createAsyncThunk(
  "adminProfile/changePassword",
  async ({ currentPassword, newPassword }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token");

      const response = await axios.put(
        `${BASE_URL}/admin/change-password`,
        { currentPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Failed to change password",
      });
    }
  }
);

const UpdateAdminProfileSlice = createSlice({
  name: "updateAdminProfile",
  initialState: {
    loading: false,
    success: false,
    data: null,
    error: null,
    passwordLoading: false,
    passwordSuccess: false,
    passwordError: null,
  },
  reducers: {
    resetProfileState: (state) => {
      state.success = false;
      state.error = null;
      state.passwordSuccess = false;
      state.passwordError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Update Profile
      .addCase(UpdateAdminProfile.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(UpdateAdminProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(UpdateAdminProfile.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Failed to update profile";
      })
      // Change Password
      .addCase(ChangeAdminPassword.pending, (state) => {
        state.passwordLoading = true;
        state.passwordSuccess = false;
        state.passwordError = null;
      })
      .addCase(ChangeAdminPassword.fulfilled, (state, action) => {
        state.passwordLoading = false;
        state.passwordSuccess = true;
      })
      .addCase(ChangeAdminPassword.rejected, (state, action) => {
        state.passwordLoading = false;
        state.passwordSuccess = false;
        state.passwordError = action.payload?.message || "Failed to change password";
      });
  },
});

export const { resetProfileState } = UpdateAdminProfileSlice.actions;
export default UpdateAdminProfileSlice.reducer;
